import fernet from 'fernet';

import {CONSTANTS} from '../../utils';

export function decryptMessage(encryptedMessage: string) {
  const secret = new fernet.Secret(CONSTANTS.fernet);

  const token = new fernet.Token({
    secret: secret,
    token: encryptedMessage,
    ttl: 0,
  });
  return token.decode();
}
